export interface ReplyTarget {
  replyToId: string
  replyPreview: string
}

export interface AndroidTextEnvelope {
  v: 1
  senderId: string
  text: string
  timestamp: number
  messageId: string
  replyTo?: { id: string; preview?: string }
  isEphemeral?: boolean
  ttl?: number
  ttlMs?: number
  ephemeralTimer?: number
  disappearingTimer?: number
  selfDestructTimer?: number
  durationMs?: number
}

export function wrapReplyEnvelope(
  plainText: string,
  senderId: string,
  messageId: string,
  reply: ReplyTarget,
  ts = Date.now(),
): AndroidTextEnvelope {
  return {
    v: 1,
    senderId: senderId.trim(),
    text: plainText,
    timestamp: ts,
    messageId,
    replyTo: { id: reply.replyToId, preview: reply.replyPreview.slice(0, 120) },
  }
}

export function parseReplyFromEnvelope(raw: unknown): ReplyTarget | null {
  if (!raw || typeof raw !== 'object') return null
  const r = (raw as { replyTo?: { id?: unknown; preview?: unknown } }).replyTo
  if (!r?.id) return null
  const id = String(r.id).trim()
  if (!id) return null
  const preview = typeof r.preview === 'string' ? r.preview : ''
  return { replyToId: id, replyPreview: preview }
}
